import { render, staticRenderFns } from "./ChatAI.vue?vue&type=template&id=505f3713&scoped=true&"
import script from "./ChatAI.vue?vue&type=script&lang=js&"
export * from "./ChatAI.vue?vue&type=script&lang=js&"
import style0 from "./ChatAI.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChatAI.vue?vue&type=style&index=1&id=505f3713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505f3713",
  null
  
)

export default component.exports